<template>
  <ContentSection class="bg-amber-100">
    <Container indent="container-tight">
      <!-- TITLE -->
      <h2
        v-if="data.heading"
        class="mb-7 max-w-title text-base font-semibold sm:mb-8 sm:text-lg"
      >
        {{ data.heading }}
      </h2>

      <!-- GRID -->
      <ul class="grid grid-cols-1 gap-x-6 gap-y-3 sm:gap-y-8">
        <!-- CARD -->
        <li v-for="(job, index) in jobs" :key="index">
          <NuxtLink
            :aria-label="`Job anzeigen: ${job.title}`"
            class="focus-default hover:bg-cream group flex h-full min-h-[6rem] w-full cursor-pointer items-center justify-between rounded-md border-3 border-transparent bg-white py-[1.25rem] pl-[1.375rem] pr-[0.875rem] transition-all hover:rounded-2xl hover:border-blue-500 hover:green:border-green-500 hover:pink:border-pink-500 sm:min-h-[8.375rem] sm:py-4 sm:px-9 md:py-6 lg:py-7"
            :to="job.url"
          >
            <div class="flex w-full max-w-full items-center">
              <IconArrowDash
                class="absolute mr-6 h-6 w-6 shrink-0 blue:text-blue-500 green:text-green-500 pink:text-pink-500 sm:mr-12 sm:h-8 sm:w-8"
              />

              <p
                class="hyphens-auto mb-2 mb-0 max-w-full pl-12 text-left text-base leading-[1.625rem] sm:pl-20 sm:text-2xl sm:leading-tight"
              >
                {{ job.title }}
              </p>
            </div>
          </NuxtLink>
        </li>
      </ul>
      <!-- BUTTON -->
      <div
        v-if="data.button_link"
        class="mt-9 flex w-full justify-end sm:mt-10"
      >
        <AppButton :to="data.button_link" aria-label="Zeige alle Downloads an">
          {{ data.button_text }}
        </AppButton>
      </div>
    </Container>
  </ContentSection>
</template>

<script setup>
import { store } from '/store.js'
const props = defineProps({
  data: { type: Object, default: () => ({}) },
})

const isSimpleLanguage = store?.isSimpleLanguage ?? false
const site = isSimpleLanguage ? 'de-plain' : 'default'

const jobs = ref([])

if (props.data.manual) {
  jobs.value = [...props.data.jobs]
} else {
  const response = await useCmsGql({
    operation: 'Jobs',
    variables: { site: site },
  })
  jobs.value = response.data?.value?.entries?.data || []
}
</script>
